<template>
	<div class="tab-list" role="tablist" :style="marginBottom ? { marginBottom } : null">
		<span v-for="(item, index) in items" :key="index">
			<slot
				:item="item"
				:isSelected="isSelected(item)"
				:sidebar="sidebar"
				:index="index"
			>
				<t-tab :value="item" :selected="isSelected(item)" :sidebar="sidebar">
					{{ item.label ? item.label : item }}
				</t-tab>
			</slot>
		</span>
	</div>
</template>

<script>
export default {
	props: {
		items: Array,
		selected: undefined,
		sidebar: Boolean,
		marginBottom: String,
	},
	data() {
		return { internalSelected: undefined, };
	},
	provide() {
		return { setSelected: this.setSelected, };
	},
	watch: {
		selected(newVal) {
			this.internalSelected = newVal;
		},
	},
	created() {
		this.internalSelected = this.selected;
	},
	methods: {
		setSelected(value) {
			this.internalSelected = value;
			this.$emit('update:selected', value);
		},
		isSelected(item) {
			return this.internalSelected !== undefined
				&& (this.internalSelected === item
					|| (this.internalSelected.id
						&& item.id && this.internalSelected.id === item.id));
		},
	},
};
</script>

<style lang="scss" scoped>
.tab-list {
	margin-right: 24px;
	margin-bottom: 16px;
	flex-basis: 240px;
	box-sizing: border-box;
}
</style>

<docs>
### Examples

#### Default
```jsx
new Vue({
	data() {
		return {
			tabs: ['Traits', 'Event History', 'Identities'],
			selectedTab: 'Traits',
		};
	},
	template: `
	<div>
		<t-tab-list :items="tabs" :selected.sync="selectedTab"/>

		<t-pane background="tint2" height="150px" center>
			<div v-show="selectedTab === tab" v-for="tab in tabs" :key="tab">
				Panel {{tab}}
			</div>
		</t-pane>
	</div>
	`
})
```
#### Sidebar
```jsx
new Vue({
	data() {
		return {
			tabs: ['Traits', 'Event History', 'Identities'],
			selectedTab: 'Traits',
		};
	},
	template: `
	<div style="display: flex;">
		<t-tab-list :items="tabs" :selected.sync="selectedTab" sidebar/>

		<t-pane background="tint2" style="width: 100%; margin-top: 0;" center>
			<div v-show="selectedTab === tab" v-for="tab in tabs" :key="tab">
				Panel {{tab}}
			</div>
		</t-pane>
	</div>
	`
})
```
</docs>